export default function(_) {
  return typeof _ === 'function';
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/isFunction.js
// module id = 622
// module chunks = 0